module.exports = "/images/veil-4.jpg";